import { YoutubeEmbed } from "@jesus-central-church/ui";
import { SbYoutubeEmbed } from "@storyblok/types/287435740670216/storyblok-components";

export function YoutubeEmbedComponent({ blok }: { blok: SbYoutubeEmbed }) {
  return <YoutubeEmbed youtubeUrl={blok.youtubeUrl?.url} />;
}
